import InstallationsForm from "./InstallationsForm";

export default InstallationsForm;